import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StripeSetupDialog from "../../components/DialogBoxComponent/StripeSetupDialog";
import HeaderToolbar from "../../components/HeaderToolbar";
import { listPaymentMethods } from "../../slices/Subscription/SubscriptionSlice";
import DashBoardData from "./DashBoardData";

export default function AdminDashboard() {
  const [count, setCount] = useState(4);
  const [openDialog, setOpenDialog] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    verifyDealer();
  }, []);

  setTimeout(function () {
    if (openDialog) {
      window.location.reload();
    }
  }, 10000);

  const verifyDealer = () => {
    if (localStorage.getItem("companyType") === "PARTNER") {
      dispatch(listPaymentMethods(localStorage.getItem("companyId")))
        .unwrap()
        .then((data) => {
          setOpenDialog(!data ? true : false);
        })
        .catch((er) => { });
    }
  };

  const handleCount = (params) => {
    setCount(params);
  };

  // const defaultProps = {
  //   center: {
  //     lat: 10.99835602,
  //     lng: 77.01502627,
  //   },
  //   zoom: 1,
  // };

  // const defaultCenter = { lat: 0, lng: 0 };
  // const defaultZoom = 2;

  // const mapOptions = {
  //   styles: [
  //     {
  //       featureType: "poi",
  //       elementType: "labels",
  //       stylers: [{ visibility: "off" }],
  //     },
  //   ],
  // };

  // useEffect(() => {
  //   loadSetting();
  // }, []);

  // const loadSetting = () => {
  //   dispatch(getListSettingsById(decoded_jwtToken.companyId))
  //     .unwrap()
  //     .then((data) => {
  //       if (data.code === "CVAI0000") {
  //         setSetting(data.data);
  //         setLatestVersion(data.data.latestVersion);
  //         setCompanySettings(data.data);
  //         localStorage.setItem("companySettings", JSON.stringify(data.data));
  //         if (data.data.viewedVersion === data.data.latestVersion)
  //           setShowPopup(false);
  //         else setShowPopup(true);
  //       }
  //     });
  // };

  // const handleMapHover = () => { };

  return (
    <>
      <div>
        <HeaderToolbar title={t("LABELNAVITEMSDASHBOARD")} dashboardPanel={"-14px"} />
        <DashBoardData count={handleCount} />
      </div>
      {openDialog && <StripeSetupDialog open={openDialog} />}
    </>
  );
}
